import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image } from 'react-native';

import { FaqStyled } from './Faq.styled';

interface Props {
  icon: string;
  title: string;
  message: string;
  to?: any;
}

export const Card = (props: Props) => {
  const { t } = useTranslation();

  return (
    <FaqStyled.Card to={props.to}>
      <FaqStyled.CardContainer>
        <img
          height={36}
          width={36}
          style={{
            alignSelf: 'start'
          }}
          src={props.icon}
        />
        <div
          style={{
            marginLeft: 10
          }}
        >
          <FaqStyled.Title
            style={{
              marginTop: 0
            }}
          >
            {props.title}
          </FaqStyled.Title>
          <FaqStyled.MessageCard>{props.message}</FaqStyled.MessageCard>
        </div>
      </FaqStyled.CardContainer>
    </FaqStyled.Card>
  );
};
